import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { UserInfo } from 'src/app/tools/models/entities/user-info';
import { ProductCategory } from '../../entities/control-tables/product-category-entity';


export class ProductCategoryRequest extends BaseRequest{
  productCategory : ProductCategory;
  constructor(userInfo : UserInfo){    
    super(userInfo);
    this.productCategory = new ProductCategory();
  }
}